import { Asset, Call, Equipment } from '@/services/backend/config/entities'

import KanbanCardItem from './kanban.card.item'

type Extended = Call & {
  Asset: Asset & { Equipment?: Equipment }
}

interface Props {
  data: Extended[]
  title: string
  description: string
  isExternal?: boolean
}

const GroupColumn = ({ isExternal, data, title, description }: Props) => {
  return (
    <div className="border border-input bg-muted/50 p-4 rounded-lg">
      <div className="mb-4">
        <h3 className="text-sm font-bold">
          {title} ({data.length})
        </h3>
        <span className="text-muted-foreground text-xs">{description}</span>
      </div>

      <div className="grid max-h-[50vh] overflow-y-auto">
        {data.map((ea) => (
          <div key={ea.id} className="mb-4 pr-2">
            <KanbanCardItem
              data={ea}
              redirectTo={
                isExternal
                  ? `/externo/${ea.id}/detalhes`
                  : `/app/entity/chamados/${ea.id}/detalhes`
              }
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default function Component({
  data,
  isExternal,
}: {
  isExternal?: boolean
  data: Extended[]
}) {
  const sortedData = data.sort((a, b) => b.id - a.id)

  // prettier-ignore
  const callGroups = {
    open:      sortedData.filter(ea=>['OPEN', 'ASSIGNED'].includes(ea.status)),
    inProgress: sortedData.filter(ea=>['IN_PROGRESS', 'DONE'].includes(ea.status)),
    closed:    sortedData.filter(ea=>['CLOSED', 'CANCELED'].includes(ea.status)),
  }

  return (
    <div className="grid overflow-x-auto pb-4">
      <div className="grid grid-cols-3 gap-4">
        <GroupColumn
          isExternal={isExternal}
          title="Abertos"
          description="Todos"
          data={callGroups.open}
        />
        <GroupColumn
          isExternal={isExternal}
          title="Em andamento"
          description="Todos"
          data={callGroups.inProgress}
        />
        <GroupColumn
          isExternal={isExternal}
          title="Encerrados"
          description="Por data"
          data={callGroups.closed}
        />
      </div>
    </div>
  )
}
